import React from 'react';
import OnboardingHelp from './OnboardingHelp';
import { useTranslation } from '../../i18n';
import TopNavigation from '../TopNavigation';
import { BackNavigation, BrandFallback, BrandImage, BrandSlot, Header, HelpBadge, PrimaryAction, PrimaryActionIcon, ProgressLabel, ProgressRegion, ProgressSegment, ProgressSegments, SecurityFooter, } from './styles';
export { OnboardingFrame, OnboardingShell } from './styles';
export { getOnboardingProgress } from './progress';
var ArrowRightIcon = function () { return (React.createElement("svg", { "aria-hidden": "true", fill: "none", focusable: "false", height: "100%", viewBox: "0 0 20 20", width: "100%" },
    React.createElement("path", { d: "M3.75 10h12.5M10.5 4.25 16.25 10l-5.75 5.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }))); };
var HelpIcon = function () { return (React.createElement("svg", { "aria-hidden": "true", fill: "none", focusable: "false", height: "1.125rem", viewBox: "0 0 20 20", width: "1.125rem" },
    React.createElement("path", { d: "M7.95 7.25a2.2 2.2 0 1 1 3.63 1.67c-.84.68-1.58 1.17-1.58 2.33", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.7" }),
    React.createElement("path", { d: "M10 14.25h.01", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2.1" }))); };
var LockIcon = function () { return (React.createElement("svg", { "aria-hidden": "true", fill: "none", focusable: "false", viewBox: "0 0 20 20" },
    React.createElement("rect", { height: "8", rx: "1.5", stroke: "currentColor", strokeWidth: "1.7", width: "11", x: "4.5", y: "9" }),
    React.createElement("path", { d: "M7 9V6.8a3 3 0 0 1 6 0V9", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.7" }))); };
export var OnboardingHeader = function (_a) {
    var logo = _a.logo, _b = _a.hideLogo, hideLogo = _b === void 0 ? false : _b;
    var _c = React.useState(false), logoFailed = _c[0], setLogoFailed = _c[1];
    var _d = React.useState(false), helpOpen = _d[0], setHelpOpen = _d[1];
    var t = useTranslation().t;
    React.useEffect(function () {
        setLogoFailed(false);
    }, [logo]);
    var showImage = Boolean(logo && !logoFailed && !hideLogo);
    return (React.createElement(Header, null,
        React.createElement(BrandSlot, null, !hideLogo &&
            (showImage ? (React.createElement(BrandImage, { alt: "Logo", src: logo, onError: function () { return setLogoFailed(true); } })) : (React.createElement(BrandFallback, null, "ID")))),
        React.createElement(HelpBadge, { type: "button", "aria-label": t('onboardingHelp.open'), "aria-haspopup": "dialog", onClick: function () { return setHelpOpen(true); } },
            React.createElement(HelpIcon, null)),
        helpOpen && React.createElement(OnboardingHelp, { onClose: function () { return setHelpOpen(false); } })));
};
export var OnboardingProgress = function (_a) {
    var currentStep = _a.currentStep, totalSteps = _a.totalSteps, _b = _a.showLabel, showLabel = _b === void 0 ? true : _b;
    var hasProgress = typeof currentStep === 'number' &&
        typeof totalSteps === 'number' &&
        isFinite(currentStep) &&
        isFinite(totalSteps) &&
        Math.floor(currentStep) === currentStep &&
        Math.floor(totalSteps) === totalSteps &&
        currentStep > 0 &&
        totalSteps > 0 &&
        currentStep <= totalSteps;
    if (!hasProgress)
        return null;
    var segments = [];
    for (var index = 0; index < totalSteps; index += 1) {
        segments.push(index);
    }
    return (React.createElement(ProgressRegion, null,
        showLabel && React.createElement(ProgressLabel, null, "ETAPA ".concat(currentStep, " DE ").concat(totalSteps)),
        React.createElement(ProgressSegments, { "aria-label": "Etapa ".concat(currentStep, " de ").concat(totalSteps), "aria-valuemax": totalSteps, "aria-valuemin": 1, "aria-valuenow": currentStep, role: "progressbar" }, segments.map(function (index) { return (React.createElement(ProgressSegment, { "$active": index < currentStep, "aria-hidden": "true", key: index })); }))));
};
export var OnboardingPrimaryButton = function (_a) {
    var ariaBusy = _a.ariaBusy, children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick;
    return (React.createElement(PrimaryAction, { "aria-busy": ariaBusy || undefined, disabled: disabled, type: "button", onClick: onClick },
        React.createElement("span", null, children),
        React.createElement(PrimaryActionIcon, null,
            React.createElement(ArrowRightIcon, null))));
};
export var OnboardingBackNavigation = function (_a) {
    var label = _a.label, _b = _a.show, show = _b === void 0 ? false : _b;
    if (!show)
        return null;
    return (React.createElement(BackNavigation, { "aria-label": label },
        React.createElement(TopNavigation, { headerPadding: 0, headerTransparent: true, showBackButton: true, title: label })));
};
export var OnboardingSecurityFooter = function (_a) {
    var text = _a.text;
    return (React.createElement(SecurityFooter, null,
        React.createElement(LockIcon, null),
        React.createElement("span", null, text)));
};
